/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TranscriptionInputs */

const en_transcription = /** @type {(inputs: TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription`)
};

const fr_transcription = /** @type {(inputs: TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcription`)
};

const de_transcription = /** @type {(inputs: TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transkription`)
};

const it_transcription = /** @type {(inputs: TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trascrizione`)
};

const ru_transcription = /** @type {(inputs: TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транскрипция`)
};

const es_transcription = /** @type {(inputs: TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcripción`)
};

const zh_cn2_transcription = /** @type {(inputs: TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转录`)
};

const ja_transcription = /** @type {(inputs: TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`転写`)
};

const hi_transcription = /** @type {(inputs: TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलिपि`)
};

const pt_pt2_transcription = /** @type {(inputs: TranscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transcrição`)
};

/**
* | output |
* | --- |
* | "Transcription" |
*
* @param {TranscriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcription = /** @type {((inputs?: TranscriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TranscriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcription(inputs)
	if (locale === "de") return de_transcription(inputs)
	if (locale === "it") return it_transcription(inputs)
	if (locale === "ru") return ru_transcription(inputs)
	if (locale === "es") return es_transcription(inputs)
	if (locale === "zh-CN") return zh_cn2_transcription(inputs)
	if (locale === "ja") return ja_transcription(inputs)
	if (locale === "hi") return hi_transcription(inputs)
	if (locale === "pt-PT") return pt_pt2_transcription(inputs)
	return en_transcription(inputs)
});